import sdl from '@jds/react-generated-sdl/JDSBadge';
import type { JDSBadgeProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSBadgeProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'normal',
    size = 'medium',
    ariaLabel = props.label?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { kind, size, ariaLabel, ...rest },
    'JDSBadge',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Badge = withLogic(Component) as React.FC<JDSBadgeProps> & {
  slotName?: string;
};

Badge.displayName = 'Badge';
Badge.slotName = 'jds_badge';

export { Badge, type JDSBadgeProps };
